import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { InmCarousel, InmCarouselItem, InmCarouselNext, InmCarouselPoint, InmCarouselPrev, InmCarouselConfig } from '@shared/components/inm-carousel';
import { VrCard } from '../../cards/vr-card/vr-card.component';
import { IMediaVr } from '@core/models';
@Component({
  selector: 'app-carousel-vr',
  imports: [
    InmCarousel,
    InmCarouselItem,
    InmCarouselNext,
    InmCarouselPrev,
    VrCard,
  ],
  templateUrl: "./carousel-vr.component.html",
  styleUrl: "./carousel-vr.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselVr {
  /** Variable de entrada que recibe la lista de videos y recorridos de realidad virtual*/
  readonly vrMedia = input<IMediaVr[]>([]);
  readonly variant = input<'default' | 'featured'>('default');
  readonly activeIndexChange = output<number>();

  /** configuracion general del carousel, define su comportamiento para distintos dispositivos ademas de sus distintas propiedades*/
  protected readonly carouselTileConfig = computed<InmCarouselConfig>(() => {
    const length = this.vrMedia().length;
    const gridConfig =
      this.variant() === 'featured'
        ? { xs: 1, sm: 1, md: 1, lg: 1, all: 0 }
        : this.getGridConfig(length);

    return {
      grid: gridConfig,
      speed: 250,
      point: { visible: true },
      slide: 1,
      touch: true,
      loop: true,
      interval: { timing: 8500 },
    };
  });

  protected readonly classWidth = computed<string>(() => {
    if (this.variant() === 'featured') return 'w-100';
    const length = this.vrMedia().length;
    return length === 1 ? 'w-50' : length === 2 ? 'w-75' : 'w-100';
  });

  private getGridConfig(itemCount: number) {
    // Mapeo directo basado en la cantidad de items
    const gridMap = {
      1: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      2: { xs: 1, sm: 2, md: 2, lg: 2, all: 0 },
      3: { xs: 1, sm: 2, md: 3, lg: 3, all: 0 },
    };

    return gridMap[itemCount as keyof typeof gridMap] || { xs: 1, sm: 2, md: 3, lg: 4, all: 0 };
  }
}
